import { useMutation, useQuery } from "@tanstack/react-query";
import { Button, Form, Input, Typography } from "antd";
import { getProfile, updateProfile } from "entities/viewer";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import ROUTES from "shared/routes";

export const ViewerRegistrationForm = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { data: profile } = useQuery({
    queryKey: ["profile"],
    queryFn: () => getProfile(),
  });

  const {
    mutate: sendProfile,
    isPending,
    error,
  } = useMutation({
    mutationFn: updateProfile,
    onSuccess() {
      if (profile?.need_sign_personal_data) {
        navigate(ROUTES.SIGN_PERSONAL_DATA);
      } else {
        const pathname = localStorage.getItem("pathname");
        if (pathname) {
          navigate(pathname);
        } else {
          navigate(ROUTES.MAIN);
        }
      }
    },
  });

  return (
    <div>
      <Typography.Title level={3}>{t("registration.title")}</Typography.Title>

      <p>{t("registration.subtitle")}</p>

      <Form
        name="nest-messages"
        onFinish={sendProfile}
        layout="vertical"
        style={{ marginBottom: 16 }}
        validateMessages={{
          required: t("registration.required", { label: "${label}" }),
        }}
      >
        <Form.Item
          name="inn"
          label={t("registration.inn")}
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="first_name"
          label={t("registration.first_name")}
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="last_name"
          label={t("registration.last_name")}
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>
        <Form.Item name="patronymic" label={t("registration.patronymic")}>
          <Input />
        </Form.Item>

        {!!error && (
          <Typography.Text
            style={{ marginBottom: 16, display: "block" }}
            type="danger"
          >
            {(error as any).response?.data?.message}
          </Typography.Text>
        )}

        <Form.Item label={null}>
          <Button
            block
            type="primary"
            style={{ marginTop: 12 }}
            loading={isPending}
            htmlType="submit"
          >
            {t("registration.submit")}
          </Button>
        </Form.Item>
      </Form>

      <Button block type="text" onClick={() => navigate(ROUTES.LOGIN)}>
        {t("registration.change_number")}
      </Button>
    </div>
  );
};
